module.exports = __webpack_public_path__ + "static/media/close-circle.96bf8b7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/close-circle.svg
// module id = 802
// module chunks = 0